function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import ExclemationMark from 'svg/exclamation-mark.svg';
import messages from '../../messages';
import styles from './WarninginfoCC.pcss';
class WarningInfoCC extends React.PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.warningInfoCC,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.warningInfoCC__iconWrapper,
                    children: /*#__PURE__*/ _jsx(ExclemationMark, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.warningInfoCC__textWrapper,
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.warningInfoCC__title,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.warningInfoCCTitle))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.warningInfoCC__subTitle,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.warningInfoCCSubTitle))
                        })
                    ]
                })
            ]
        });
    }
}
export default withStyles(styles)(WarningInfoCC);
